import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FieldAnswerFeedback } from '../../../ui/field-answer-feedback/field-answer-feedback';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { getTextInputFieldError } from '../../../ui/text-input-field/text-input-field-utils';
import { useError } from '../../../field-error';
import { TextInputWUT } from '../../../inputs/text-input-wut/text-input-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
export const QuizShortTextWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    placeholder,
    required = true,
    description,
    value = '',
    onChange,
    onBlur,
    onFocus,
    error,
    type = 'text',
    disabled = false,
    readOnly,
    customErrors,
    validation,
    countryCode,
    prefix,
    externalData,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    questionImage,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement,
    questionImageAltText
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const _error = getTextInputFieldError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, FIELD_TYPES.QUIZ_SHORT_TEXT, countryCode == null ? void 0 : countryCode.toLocaleLowerCase());
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      htmlFor: inputId,
      labelId: labelId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement,
      imageAltText: questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TextInputWUT, {
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      type: type,
      disabled: disabled,
      readOnly: readOnly,
      prefix: prefix,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy,
      hasError: hasError
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedback, {
      target: target,
      externalData: externalData
    }))
  });
};
//# sourceMappingURL=quiz-short-text-wut.js.map